import PropTypes from 'prop-types';
import React, { Component } from 'react';
import utils from '../../utils/utilities.js';
import FormGroup from './FormGroup.jsx';

export default class TextareaField extends Component {

    static propTypes = {
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        classNames: PropTypes.string,
        label: PropTypes.any,
        hasError: PropTypes.any,
        disabled: PropTypes.bool,
        required: PropTypes.bool,
        inputAttributes: PropTypes.object,
        fieldId: PropTypes.string
    }

    static defaultProps = {
        label: null,
        hasError: true,
        disabled: false,
        required: false,
        classNames: null,
        fieldId: "textarea_" + utils.generateRandomHash()
    }

    render() {
        return (
            <FormGroup {...this.props} fieldId={this.props.fieldId}>
                <textarea
                    id={this.props.fieldId}
                    value={this.props.value}
                    onChange={this.props.onChange}
                    disabled={this.props.disabled}
                    {...this.props.inputAttributes}
                />
            </FormGroup>
        )
    }
}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/Textarea.jsx